<template>
    <form @submit.prevent>
        <h6 class="heading-small text-muted mb-4">ขนาดพื้นที่ร้าน</h6>
        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> พื้นที่ร้านทั้งหมด (ตารางเมตร) <span class="text-muted">ใช้สำหรับบริการเสริมในอนาคต</span>
                    </label>
                    <div class="col-lg-6">
                        <input
                            type="number"
                            class="form-control hide-arrow"
                            placeholder="พื้นที่ร้านทั้งหมด (ตารางเมตร)"
                            :class="{ 'is-invalid': submittEdit && $v.area.branceArea.$error }"
                            v-model="area.branceArea"
                        />
                        <label
                            v-if="submittEdit && !$v.area.branceArea.required"
                            class="invalid-feedback"
                        >พื้นที่ร้านทั้งหมด (ตารางเมตร)</label>
                    </div>
                </div>
            </div>
        </div>
        <hr class="my-4" />
        <h6 class="heading-small text-muted mb-4">ข้อมูลพื้นที่สำหรับใช้สอย</h6>
        <div class="row">
            <div class="col-lg-12">
                <!-- storage-space -->
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> คุณมีพื้นที่ว่างสำหรับเก็บของหรือไม่ 
                        <i class="fas fa-exclamation-circle fa-xs text-muted" style="cursor: pointer;" 
                            v-b-tooltip title="พื้นที่เก็บของหลังร้าน หรือ บริเวณภายในอาคาร ที่ตั้งร้าน">
                        </i>
                    </label>
                    <div class="col-lg-12">
                        <b-form-group>
                            <b-form-radio v-model="area.storageSpace" :state="($v.area.storageSpace.$error) ? false : null" name="storage-space" value="YES">มี</b-form-radio>
                            <div class="d-flex ml-2 my-3" v-if="area.storageSpace == 'YES'">
                                <label class="text-muted d-flex align-items-center px-2">พื้นที่ว่าง (ตารางเมตร)</label>
                                <div class="col-lg-4">
                                    <input
                                        v-model="area.storageSpaceFree" 
                                        type="number"
                                        class="form-control hide-arrow"
                                        :class="{ 'is-invalid': submittEdit && $v.area.storageSpaceFree.$error }"
                                        placeholder="พื้นที่ว่าง (ตารางเมตร)"
                                    />
                                    <label
                                        v-if="submittEdit && !$v.area.storageSpaceFree.required"
                                        class="invalid-feedback"
                                    >กรุณากรอกพื้นที่ว่าง (ตารางเมตร)</label>
                                </div>
                                <label class="text-muted d-flex align-items-center px-1">ความสูง (เมตร)
                                    <i class="fas fa-exclamation-circle fa-xs text-muted px-1" style="cursor: pointer;" 
                                        v-b-tooltip title="เลือกความสูง โดยวัดจากพื้นจนถึงเพดาน เพื่อใช้ในกรณีเลือกเฟอร์นิเจอร์ที่มีความสูง เหมาะกับร้านของคุณ">
                                    </i>
                                </label>
                                <div class="col-lg-3">
                                    <b-form-select v-model="area.storageSpaceHeight"  :options="height" :state="($v.area.storageSpaceHeight.$error) ? false : null">
                                        <template v-slot:first>
                                        <option :value="null || ''" disabled>{{'กรุณาเลือก'}}</option>
                                        </template>
                                    </b-form-select>
                                    <label
                                        v-if="submittEdit && !$v.area.storageSpaceHeight.required"
                                        class="invalid-feedback"
                                    >กรุณาเลือกความสูง (เมตร)</label>
                                </div>
                               
                            </div>
                            <b-form-radio v-model="area.storageSpace" :state="($v.area.storageSpace.$error) ? false : null" name="storage-space" value="NO" @change="clearStorageSpace()">ไม่มีพื้นที่ว่าง</b-form-radio>
                        </b-form-group>
                    </div>
                </div>
                <!-- storage-reng -->
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> คุณมีพื้นที่ว่างสำหรับเก็บของ<b>ให้เช่า</b>หรือไม่ 
                        <i class="fas fa-exclamation-circle fa-xs text-muted" style="cursor: pointer;" 
                            v-b-tooltip title="พื้นที่เก็บของหลังร้าน หรือ บริเวณภายในอาคาร ที่ตั้งร้าน">
                        </i>
                    </label>
                    <div class="col-lg-12">
                        <b-form-group>
                            <b-form-radio v-model="area.storageReng" :state="($v.area.storageReng.$error) ? false : null" name="storage-reng" value="YES">มี สะดวกให้เช่าพื้นที่ได้</b-form-radio>
                            <div class="d-flex ml-2 my-3" v-if="area.storageReng == 'YES'">
                                <label class="text-muted d-flex align-items-center px-2">พื้นที่ว่าง (ตารางเมตร)</label>
                                <div class="col-lg-4">
                                    <input
                                        v-model="area.storageRengFree" 
                                        type="number"
                                        class="form-control hide-arrow"
                                        :class="{ 'is-invalid': submittEdit && $v.area.storageRengFree.$error }"
                                        placeholder="พื้นที่ว่าง (ตารางเมตร)"
                                    />
                                    <label
                                        v-if="submittEdit && !$v.area.storageRengFree.required"
                                        class="invalid-feedback"
                                    >กรุณากรอกพื้นที่ว่าง (ตารางเมตร)</label>
                                </div>
                                <label class="text-muted d-flex align-items-center px-1">ความสูง (เมตร)
                                    <i class="fas fa-exclamation-circle fa-xs text-muted px-1" style="cursor: pointer;" 
                                        v-b-tooltip title="เลือกความสูง โดยวัดจากพื้นจนถึงเพดาน เพื่อใช้ในกรณีเลือกเฟอร์นิเจอร์ที่มีความสูง เหมาะกับร้านของคุณ">
                                    </i>
                                </label>
                                <div class="col-lg-3">
                                    <b-form-select v-model="area.storageRengHeight"  :options="height" :state="($v.area.storageRengHeight.$error) ? false : null">
                                        <template v-slot:first>
                                        <option :value="null || ''" disabled>{{'กรุณาเลือก'}}</option>
                                        </template>
                                    </b-form-select>
                                    <label
                                        v-if="submittEdit && !$v.area.storageRengHeight.required"
                                        class="invalid-feedback"
                                    >กรุณาเลือกความสูง (เมตร)</label>
                                </div>
                               
                            </div>
                            <b-form-radio v-model="area.storageReng" :state="($v.area.storageReng.$error) ? false : null" name="storage-reng" value="HOWEVER" @change="clearStorageReng()">มี แต่ไม่สะดวกให้เช่าพื้นที่</b-form-radio>
                            <b-form-radio v-model="area.storageReng" :state="($v.area.storageReng.$error) ? false : null" name="storage-reng" value="NO" @change="clearStorageReng()">ไม่มีพื้นที่ว่าง</b-form-radio>
                        </b-form-group>
                    </div>
                </div>
                <!-- billboard-reng -->
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> คุณมีพื้นที่สำหรับติดป้ายโฆษณาให้เช่าหรือไม่
                    </label>
                    <div class="col-lg-12">
                        <b-form-group>
                            <b-form-radio v-model="area.billboardReng" :state="($v.area.billboardReng.$error) ? false : null" name="billboard-reng" value="YES">มี สะดวกให้เช่าพื้นที่สำหรับติดป้ายโฆษณา</b-form-radio>
                            <div class="d-flex ml-2 my-3" v-if="area.billboardReng == 'YES'">
                                <label class="text-muted d-flex align-items-center px-2">พื้นที่ว่าง (ตารางเมตร)</label>
                                <div class="col-lg-4">
                                    <input
                                        v-model="area.billboardRengFree" 
                                        type="number"
                                        class="form-control hide-arrow"
                                        :class="{ 'is-invalid': submittEdit && $v.area.billboardRengFree.$error }"
                                        placeholder="พื้นที่ว่าง (ตารางเมตร)"
                                    />
                                    <label
                                        v-if="submittEdit && !$v.area.billboardRengFree.required"
                                        class="invalid-feedback"
                                    >กรุณากรอกพื้นที่ว่าง (ตารางเมตร)</label>
                                </div>
                                <label class="text-muted d-flex align-items-center px-1">ยาว (เมตร)</label>
                                <div class="col-lg-4">
                                    <input
                                        v-model="area.billboardRengLength" 
                                        type="number"
                                        class="form-control hide-arrow"
                                        :class="{ 'is-invalid': submittEdit && $v.area.billboardRengLength.$error }"
                                        placeholder="ยาว (เมตร)"
                                    />
                                    <label
                                        v-if="submittEdit && !$v.area.billboardRengLength.required"
                                        class="invalid-feedback"
                                    >กรุณากรอกความยาว (เมตร)</label>
                                </div>
                               
                            </div>
                            <b-form-radio v-model="area.billboardReng" :state="($v.area.billboardReng.$error) ? false : null" name="billboard-reng" value="HOWEVER" @change="clearBillboardReng()">มี แต่ไม่สะดวกให้เช่าพื้นที่สำหรับติดป้ายโฆษณา</b-form-radio>
                            <b-form-radio v-model="area.billboardReng" :state="($v.area.billboardReng.$error) ? false : null" name="billboard-reng" value="NO" @change="clearBillboardReng()">ไม่มีพื้นที่</b-form-radio>
                        </b-form-group>
                    </div>
                </div>
                <!-- kitchen-area -->
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ภายในร้านของคุณมีพื้นที่ทำครัวหรือไม่ (หากมี คุณสะดวกให้เช่าพื้นที่และมีพื้นที่สำหรับล้างอุปกรณ์ หรือไม่) 
                        <i class="fas fa-exclamation-circle fa-xs text-muted" style="cursor: pointer;" 
                            v-b-tooltip title="ไม่ผัด ไม่ทอด ไม่ใช้เตาแก๊ส ใช้เพียงไมโครเวฟ ประกอบอาหาร">
                        </i>
                    </label>
                    <div class="col-lg-12">
                        <b-form-group>
                            <b-form-radio v-model="area.kitchenArea" :state="($v.area.kitchenArea.$error) ? false : null" name="kitchen-area" value="YES">มี สะดวกให้เช่าพื้นที่ และมีพื้นที่สำหรับล้างอุปกรณ์</b-form-radio>
                            <b-form-radio v-model="area.kitchenArea" :state="($v.area.kitchenArea.$error) ? false : null" name="kitchen-area" value="HOWEVER">มี แต่ไม่สะดวกให้เช่าพื้นที่ และไม่มีพื้นที่สำหรับล้างอุปกรณ์</b-form-radio>
                            <b-form-radio v-model="area.kitchenArea" :state="($v.area.kitchenArea.$error) ? false : null" name="kitchen-area" value="NO">ไม่มีพื้นที่ทำครัว</b-form-radio>
                        </b-form-group>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="$USER_LOGIN.get().isAdmin">
            <hr class="my-4" />
            <div class="mt-4 w-100 text-right">
                <b-button variant="secondary" @click="resetForm()">กรอกใหม่</b-button>
                <b-button type="submit" variant="info" @click="createOrUpdateArea()">บันทึก</b-button>
            </div>
        </template>
    </form>
</template>

<script>
import {
  required,
  requiredIf
} from "vuelidate/lib/validators"
import validatePop from "@/plugins/validatePop.js"
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";
export default {
    name:"BranceArea",
    props: {
        submittEdit: Boolean,
        area: Object,
    },
    data(){
        return {
            height: [
                { value: '2.00' , text: "2 เมตร" },
                { value: '2.50' , text: "2.5 เมตร" },
                { value: '3.00' , text: "3 เมตร" },
                { value: '4.00' , text: "3 เมตรขึ้นไป" },
            ],
        }
    },
    validations: {
        area:{
            branceArea:{ required },
            storageSpace:{ required },
            storageSpaceFree: { required: requiredIf(function (storage) {
                return storage.storageSpace == 'YES'
            })},
            storageSpaceHeight: { required: requiredIf(function (storage) {
                return storage.storageSpace == 'YES'
            })},
            storageReng:{ required },
            storageRengFree: { required: requiredIf(function (storage) {
                return storage.storageReng == 'YES'
            })},
            storageRengHeight: { required: requiredIf(function (storage) {
                return storage.storageReng == 'YES'
            })},
            billboardReng:{ required },
            billboardRengFree: { required: requiredIf(function (storage) {
                return storage.billboardReng == 'YES'
            })},
            billboardRengLength: { required: requiredIf(function (storage) {
                return storage.billboardReng == 'YES'
            })},
            kitchenArea:{ required },
        }
    },
    methods:{
        createOrUpdateArea(){
            this.$emit('update:submittEdit', true);
            this.$v.area.$touch();
            if (this.$v.area.$invalid) {
                return false
            }
            this.$emit('handleLoader');
            this.$http
                .post(
                this.$API_URL + "/shop/shop/detail",
                {
                    type: "area",
                    area_shop: this.area.branceArea,
                    storage_space: this.area.storageSpace,
                    storage_space_meters: (this.area.storageSpaceFree == '') ? '0' : this.area.storageSpaceFree ,
                    storage_space_height: (this.area.storageSpaceHeight == '') ? '0' : this.area.storageSpaceHeight,
                    storage_rent: this.area.storageReng,
                    storage_rent_meters: (this.area.storageRengFree == '') ? '0' : this.area.storageRengFree,
                    storage_rent_height: (this.area.storageRengHeight == '') ? '0' : this.area.storageRengHeight,
                    billboard_rent: this.area.billboardReng,
                    billboard_rent_meters: (this.area.billboardRengFree == '') ? '0' : this.area.billboardRengFree,
                    billboard_rent_length: (this.area.billboardRengLength == '') ? '0' : this.area.billboardRengLength,
                    kitchen_area: this.area.kitchenArea
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                }
                )
                .then(res => {
                    let checkError = validatePop( res )
                    this.$emit('handleLoader');
                    if( !checkError.status ){
                        showErrorModal( checkError.msg )
                        return false
                    }
                    showSuccessModal('บันทึกข้อมูลพื้นที่ร้านสำเร็จ')
                })
                .catch(error => {
                });
        },
        clearStorageSpace(){
            this.area.storageSpaceFree = ''
            this.area.storageSpaceHeight = ''
        },
        clearStorageReng(){
            this.area.storageRengFree = ''
            this.area.storageRengHeight = ''
        },
        clearBillboardReng(){
            this.area.billboardRengFree = ''
            this.area.billboardRengLength = ''
        },
        resetForm(){
            Object.keys(this.area).forEach(key => {
                this.area[key] = '';
            });
        }
    },
    computed:{
    }
}
</script>

<style>

</style>